module.exports = __webpack_public_path__ + "img/deslogar.40876e91.svg";